import { render } from "./AvatarGroup.vue?vue&type=template&id=6be9fa06&ts=true"
import script from "./AvatarGroup.vue?vue&type=script&lang=ts"
export * from "./AvatarGroup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__